import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components'
// import { deviceLayout } from 'styles/breakpoint'

type BannerContainerProps = {
  ['data-banner-height']?: number
}

export const StyledBannerContainer = styled.div`
  position: relative;
  z-index: 11;
  overflow: hidden;
  width: 100%;
  height: ${(props: BannerContainerProps) =>
    props?.['data-banner-height'] ? props?.['data-banner-height'] + 'px' : '0'};
  padding-top: ${(props: BannerContainerProps) =>
    props?.['data-banner-height'] ? '0' : '56.25%'};
  margin-bottom: 32px;
  background-color: white;

  .animation-banner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    object-fit: cover;
  }

  .premium-badge {
    z-index: 1;
    top: 30px;
    left: 204px;
    position: absolute;
  }
  ${MediaQueries.mbDown} {
    z-index: 10;
    padding-top: ${(props: BannerContainerProps) =>
      props?.['data-banner-height'] ? '0' : '177%'};
    .premium-badge {
      left: 16px;
    }
  }
`
export const StyledContentArea = styled.div`
  position: absolute;
  z-index: 10;

  .content {
    padding: 24px 20px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 12px;
  }

  .down-icon {
    width: 40px;
    height: 40px;
    margin-top: 32px;
    cursor: pointer;
  }

  ${MediaQueries.mbUp} {
    max-width: 464px;
    &[data-position='top'] {
      top: 20%;
      left: 204px;
      .down-icon {
        margin-left: 30px;
      }
    }
    &[data-position='bottom'] {
      bottom: 80px;
      right: 204px;
      .down-icon {
        float: right;
        margin-right: 30px;
      }
    }
  }

  ${MediaQueries.mbDown} {
    width: calc(100% - 2rem);
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    &[data-position='top'] {
      top: 80px;
      .down-icon {
        margin-left: 30px;
      }
    }
    &[data-position='bottom'] {
      bottom: 200px;
      .down-icon {
        float: right;
        margin-right: 30px;
      }
    }
  }

  .title {
    margin-bottom: 16px;
    * {
      font-size: 32px;
    }
  }

  .description {
    color: white;
    font-size: 22px;
    font-weight: 600;
    line-height: 26px;
    a {
      text-decoration: none;
    }
  }
`
